import type { Transition, Variant } from 'motion/react';

export const COLLAPSED_PEEK = 12;
export const SCALE_STEP = 0.05;
export const EXPANDED_GAP = 12;
const EXIT_DRIFT = 16;

export const TOAST_TRANSITION = {
  duration: 0.3,
  ease: [0.21, 1.02, 0.73, 1],
} satisfies Transition;

export const EXIT_TRANSITION = {
  duration: 0.1,
  ease: 'easeOut',
} satisfies Transition;

export interface ToastVariantCustom {
  index: number;
  expandedY: number;
  isExpanded: boolean;
}

export const TOAST_VARIANTS = {
  initial: { opacity: 0, y: '100%' },
  collapsed: ({ index }: ToastVariantCustom) => ({
    opacity: 1,
    y: -(index * COLLAPSED_PEEK),
    scale: 1 - index * SCALE_STEP,
  }),
  expanded: ({ expandedY }: ToastVariantCustom) => ({
    opacity: 1,
    y: expandedY,
    scale: 1,
  }),
  exit: ({ expandedY, isExpanded }: ToastVariantCustom) => ({
    opacity: 0,
    y: isExpanded ? `calc(${expandedY}px + ${EXIT_DRIFT}px)` : `${EXIT_DRIFT}px`,
    transition: EXIT_TRANSITION,
  }),
} satisfies Record<string, Variant>;
